import React from 'react';
import './deal info.css'
import { MDBContainer, MDBRow, MDBCol, MDBModal, MDBModalHeader, MDBModalBody, MDBBtn, MDBIcon } from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message, Empty, Popconfirm, TreeSelect } from "antd";
import Skeleton from 'react-loading-skeleton';
import Tooltip from '@material-ui/core/Tooltip';
import { Info, Edit } from '@material-ui/icons';
import PaginationButtons from '../../component/pagenation/pagenation';
import moment from 'moment';
import { UploadOutlined } from '@ant-design/icons';
import { hasValue } from "../../validations/validations";
import CloseIcon from '@material-ui/icons/Close';
import { TreeNode } from 'antd/lib/tree-select';
import InsideTable from '../../component/insideTable/insideTable';

class DealInfo extends React.Component {
    state = {
        actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
        id: this.props.location.state.data.id,
        status: this.props.location.state.data.status,
        type: this.props.location.state.data.type,
        totalInstallments: this.props.location.state.data.totalInstallments,
        paidInstallments: this.props.location.state.data.paidInstallments,
        cost: this.props.location.state.data.cost,
        discount: this.props.location.state.data.discount,
        advertisement: this.props.location.state.data.advertisement ? this.props.location.state.data.advertisement : null,
        user: this.props.location.state.data.user ? this.props.location.state.data.user : null,
        project: this.props.location.state.data.project ? this.props.location.state.data.project : null,
        clientName: this.props.location.state.data.clientName,
        clientPhone: this.props.location.state.data.clientPhone,
        clientIdNumber: this.props.location.state.data.clientIdNumber,
        recieptFile: this.props.location.state.data.recieptFile,
        paymentType: this.props.location.state.data.paymentType,
        soldBy: this.props.location.state.data.soldBy ? this.props.location.state.data.soldBy : 'SAAEI',
        depositPayType: this.props.location.state.data.depositPayType,
        clientType: this.props.location.state.data.clientType,
        clientCountry: this.props.location.state.data.clientCountry ? this.props.location.state.data.clientCountry.id : null,
        isCollected: this.props.location.state.data.isCollected,
        collectedDate: this.props.location.state.data.collectedDate,
        collectionReciept: this.props.location.state.data.collectionReciept,
        employee: this.props.location.state.data.employee ? this.props.location.state.data.employee : [],
        actionUser: this.props.location.state.data.actionUser ? this.props.location.state.data.actionUser : null,
        pages: 1,
        page: 1,
        installments: [],
        attachmentModal: false,
        pages2: 1,
        page2: 1,
        attachments: [],
        description: "",
        file: null,
        fileName: '',
        fileType: 'data',
        users: [],
        countries: []

    };

    constructor(props) {
        super(props)
        window.scrollTo(0, 0)
        this.getInstallments(1)
        this.getAttachments(1)
        this.getUserWithoutPagenation()
        this.getCountries()
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }

    componentDidMount() {
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }
    getCountries = () => {
        axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`)
            .then(response => {
                console.log(response.data)
                this.setState({ countries: response.data.data })
            })
            .catch(error => {
                console.log("ALL countries ERROR")
                console.log(error.response)
            })
    }
    getUserWithoutPagenation = () => {
        axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en',
            },
        }).then(response => {
            console.log(response.data.data)
            this.setState({ users: response.data.data })
        })
            .catch(error => {
                console.log("ALL users ERROR")
                console.log(error.response)
            })
    }
    getAttachments = (page) => {
        axios.get(`${BASE_END_POINT}attachments/${this.state.advertisement.id}/withPagenation/get?page=${page}`, {
            headers: {
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        })
            .then(response => {
                console.log(response.data)
                this.setState({
                    attachments: response.data.data,
                    page2: parseInt(response.data.page),
                    pages2: response.data.pageCount
                })
            })
            .catch(error => {
                console.log("ALL ads ERROR")
                console.log(error.response)
            })
    }
    getInstallments = (page) => {
        axios.get(`${BASE_END_POINT}deals/${this.state.advertisement.id}/installments/get?page=${page}`, {
            headers: {
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        })
            .then(response => {
                console.log(response.data)
                this.setState({
                    installments: response.data.data,
                    page: parseInt(response.data.page),
                    pages: response.data.pageCount
                })
            })
            .catch(error => {
                console.log("ALL ads ERROR")
                console.log(error.response)
            })
    }

    delete = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}deal/${this.props.location.state.data.id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            },
        })
            .then(response => {
                console.log("Transaction DELETED")
                l.then(() => message.success(allStrings.done, 2.5))
                this.props.history.goBack()
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    update = () => {
        const { clientCountry, clientIdNumber, clientName, clientPhone, clientType, employee, soldBy, depositPayType
        } = this.state
        if (hasValue(clientPhone) && hasValue(clientName)) {
            let l = message.loading('Wait..', 2.5)
            let data = new FormData()
            data.append('clientName', clientName)
            data.append('clientPhone', clientPhone)
            data.append('clientIdNumber', clientIdNumber)
            data.append('clientCountry', clientCountry)
            data.append('clientType', clientType)
            data.append('soldBy', soldBy)
            data.append('depositPayType', depositPayType)
            data.append('employee', JSON.stringify(employee))
            console.log(Array.from(data))
            axios.put(`${BASE_END_POINT}deals/${this.props.location.state.data.id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    console.log("deal UPDATED  ", response.data)
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.props.history.goBack()
                })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
                })
        }
    }


    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.update()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    installmentsTable = () => {
        const columns = [
            {
                title: '#',
                dataIndex: 'id',
                key: 'id'
            },
            {
                title: allStrings.installmentNumber,
                dataIndex: 'installmentNumber',
                key: 'installmentNumber'
            },
            {
                title: allStrings.cost,
                dataIndex: 'cost',
                key: 'cost'
            },
            {
                title: allStrings.tax,
                dataIndex: 'tax',
                key: 'tax'
            },
            {
                title: allStrings.totalCost,
                dataIndex: 'totalCost',
                key: 'totalCost'
            },
            {
                title: allStrings.status,
                dataIndex: 'status',
                key: 'status',
                render: (val) => {
                    const typeMap = {
                        PENDING: allStrings.pending,
                        REQUIRED: allStrings.required,
                        PAID: allStrings.paid
                    };
                    return typeMap[val.status] || val.status;
                }
            }
        ];

        return (
            <InsideTable
                isRTL={this.props.isRTL}
                allStrings={allStrings}
                data={this.state.installments}
                columns={columns}
                viewAction={(val) => this.props.history.push("installmentInfo", { data: val })}
                editAction={(val) => this.props.history.push('installmentInfo', { data: val, actionType: 'EDIT' })}
                loading={this.state.loading}
                title={allStrings.installments}
                subtitle="إدارة جميع الاقساط الخاصة بعملية البيع"
                page={this.state.page}
                pages={this.state.pages}
                onPageChange={this.getInstallments}
            />
        );
    }
    addAttachment = () => {
        const { description, file, user } = this.state
        if (hasValue(description) && file !== null) {
            let l = message.loading('Wait..', 2.5)
            let data = new FormData()
            data.append('description', description)
            data.append('file', file)
            data.append('user', user.id)
            axios.post(`${BASE_END_POINT}attachments/${this.state.advertisement.id}/createAttachment`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    console.log("attachment ADDED  ", response.data)
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.setState({ attachmentModal: false, description: '', file: null, fileName: '', fileType: 'data' })
                    this.getAttachments(this.state.page, false)
                })
                .catch(error => {
                    console.log("error   ", error.response)
                    console.log("error2   ", error)
                    l.then(() => message.error(allStrings.error, 2.5))
                })
        }
    }
    removeAttachment = (id) => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}attachments/${id}`, {
            headers: {
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        })
            .then(response => {
                console.log("attachment REMOVED")
                l.then(() => message.success(allStrings.done, 2.5))
                this.getAttachments(this.state.page, false)
            })
            .catch(error => {
                console.log("error   ", error.response)
                console.log("error2   ", error)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    fileChangedHandler = event => {
        this.setState({
            file: event.target.files[0],
            fileName: event.target.files[0].name,
            fileType: "data"
        })
    }
    removeFile = () => {
        this.setState({
            file: null,
            fileName: '',
            fileType: "url"
        });
    }
    attachmentsTable = () => {
        const columns = [
            {
                title: '#',
                dataIndex: 'id',
                key: 'id'
            },
            {
                title: allStrings.description,
                dataIndex: 'description',
                key: 'description'
            },
            {
                title: allStrings.file,
                key: 'file',
                render: (val) => val.file ? (
                    <a style={{ fontSize: '15px', fontWeight: '600', color: '#1D9598', textDecoration: 'none' }}
                        href={val.file} target="_blank" rel="noopener noreferrer" title="">
                        {allStrings.showFile}
                    </a>
                ) : null
            }
        ];

        return (
            <InsideTable
                isRTL={this.props.isRTL}
                allStrings={allStrings}
                data={this.state.attachments}
                columns={columns}
                removeAction={this.removeAttachment}
                toggleMedia={this.toggleAttachment}
                loading={this.state.loading}
                title={allStrings.attachments}
                addBtnTitle='اضافه ملف جديد'
                subtitle="إدارة جميع الملفات الخاصة بعملية البيع"
                page={this.state.page2}
                pages={this.state.pages2}
                onPageChange={this.getAttachments}
            />
        );
    };
    submitHandlerAddAttachment = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.addAttachment()
    };
    toggleAttachment = () => {
        this.setState({
            attachmentModal: !this.state.attachmentModal,
        });
    }
    attachmentModal = () => (
        <MDBModal isOpen={this.state.attachmentModal} toggle={this.toggleAttachment} size="lg">
            <MDBModalHeader toggle={this.toggleAttachment}>{allStrings.completeData}</MDBModalHeader>
            <MDBModalBody>
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            <form
                                onSubmit={this.submitHandlerAddAttachment}
                                noValidate
                            >
                                <div className="grey-text">
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                                <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.description}</label>
                                                <input name='description' style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" id="form8" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل الوصف..." />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2">
                                                <input key={this.state.file} type='file' className="upImgs2" onChange={this.fileChangedHandler}></input>
                                                <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.file}</span></span>
                                            </div>
                                            <div className="preview">
                                                {this.state.file &&
                                                    <div style={{ display: "inline-block", width: '100%' }}>

                                                        <span style={{
                                                            border: '1px solid mediumaquamarine', margin: "20px",
                                                            display: "inline-block",
                                                            width: '365px',
                                                            borderRadius: "20px",
                                                            padding: "5px 15px"
                                                        }}>
                                                            <span className="imgName">{this.state.fileName}</span>
                                                            <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                                onClick={this.removeFile} style={{ right: "49%", top: '130px' }}></MDBIcon>
                                                        </span>
                                                        <a style={{ fontSize: '18px', fontWeight: '500', color: '#127275', display: 'inline-block' }}
                                                            href={this.state.file} target="_blank" rel="noopener noreferrer" title="">
                                                            <p>{allStrings.showFile}</p>
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </MDBCol>
                                    </MDBRow>

                                </div>
                                <div className="drawer-action-footer">
                                    <MDBBtn type="button" className="btn-cancel" onClick={this.toggleAttachment}>
                                        إلغاء
                                    </MDBBtn>
                                    <MDBBtn type="submit" className="btn-submit">
                                        {allStrings.add}
                                    </MDBBtn>
                                </div>
                            </form>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </MDBModalBody>
        </MDBModal>
    )

    render() {
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CONTACT-REQUEST')) return <Redirect to='/Home' />

        return (
            <div className="App">
                <MDBContainer>
                    {this.attachmentModal()}
                    <MDBRow>
                        <MDBCol md="12" >
                            <div className="infoCard">
                                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                                    <CardMedia
                                        style={{ height: "0px" }}
                                    />
                                    <CardHeader></CardHeader>
                                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                                        <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                                            <span className="material-icons" style={{ color: 'white', fontSize: 20 }}>content_paste</span>
                                        </div>
                                        <div className="tableTitle" style={{
                                            display: 'inline-block', marginTop: '-60px',
                                            marginLeft: '0', marginRight: '0'
                                        }}>
                                            <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                                        </div>
                                    </div>
                                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                                        <MDBContainer>

                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <form
                                                        className="needs-validation"
                                                        onSubmit={this.submitHandler}
                                                        noValidate
                                                    >

                                                        <div className="grey-text">
                                                            {this.state.actionType === "VIEW" &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="12">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.id} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }{this.state.actionType === "VIEW" &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.cost}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.cost} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.discount}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.discount} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.actionType === "VIEW" && this.state.installments.length > 0 &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalInstallments}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.totalInstallments} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.paidInstallments}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.paidInstallments} type="text" id="form8" className="form-control" onChange={this.changeHandler} validate />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }{this.state.clientName && this.state.clientPhone &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientName}</label>
                                                                            <input disabled={this.state.actionType === 'VIEW' ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.clientName} type="text" id="form8" name="clientName" className="form-control" onChange={this.changeHandler} validate placeholder="أدخل البيانات..." />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientPhone}</label>
                                                                            <input disabled={this.state.actionType === 'VIEW' ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.clientPhone} type="text" id="form8" name="clientPhone" className="form-control" onChange={this.changeHandler} validate placeholder="أدخل البيانات..." />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.clientIdNumber &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form83" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.cardNum}</label>
                                                                            <input disabled={this.state.actionType === 'VIEW' ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.clientIdNumber} type="text" id="form83" name="clientIdNumber" className="form-control" onChange={this.changeHandler} validate placeholder="أدخل البيانات..." />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="6">
                                                                        <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientCountry}</label>
                                                                        <TreeSelect virtual={false}
                                                                            disabled={this.state.actionType === 'VIEW' ? true : false}
                                                                            showSearch={true}
                                                                            value={this.state.clientCountry}
                                                                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                                            treeCheckable={false}
                                                                            treeNodeFilterProp="title"
                                                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                            placeholder={allStrings.country}
                                                                            onChange={(value) => {
                                                                                console.log(value)
                                                                                this.setState({ 'clientCountry': value })
                                                                            }}

                                                                        >
                                                                            {this.state.countries.map(val => (
                                                                                <TreeNode value={val.id} title={this.props.isRTL ? val.countryName_ar : val.countryName_en} key={val.id} />
                                                                            ))}
                                                                        </TreeSelect>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                <MDBCol md="6">
                                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientType}</label>
                                                                    <TreeSelect virtual={false}
                                                                        showSearch={true}
                                                                        disabled={this.state.actionType === 'VIEW' ? true : false}
                                                                        value={this.state.clientType}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                                        treeCheckable={false}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.clientType}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ 'clientType': value })
                                                                        }}

                                                                    >
                                                                        <TreeNode value="RENT" title={allStrings.rent} key="RENT" />
                                                                        <TreeNode value="HOUSING" title={allStrings.housing} key="HOUSING" />
                                                                        <TreeNode value="INVESTMENT" title={allStrings.investment} key="INVESTMENT" />
                                                                        <TreeNode value="OFF-PLAN-SALE" title={allStrings.offPlanSale} key="OFF-PLAN-SALE" />


                                                                    </TreeSelect>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee}</label>
                                                                    <TreeSelect virtual={false}
                                                                        showSearch={true}
                                                                        disabled={this.state.actionType === 'VIEW' ? true : false}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                                        treeCheckable={true}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.employee}
                                                                        value={this.state.employee}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ 'employee': value })
                                                                        }}
                                                                    >
                                                                        {this.state.users.map(val => (
                                                                            <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                                                        ))}
                                                                    </TreeSelect>
                                                                </MDBCol>

                                                            </MDBRow>
                                                            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                <MDBCol md="6">
                                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.soldBy}</label>
                                                                    <TreeSelect virtual={false}
                                                                        value={this.state.soldBy}
                                                                        disabled={this.state.actionType === 'VIEW' ? true : false}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                                        treeCheckable={false}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.soldBy}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ 'soldBy': value })
                                                                        }}
                                                                    >
                                                                        <TreeNode value="SAAEI" title='ساعي' key="SAAEI" />
                                                                        <TreeNode value="DEVELOPER" title='المطور' key="DEVELOPER" />
                                                                    </TreeSelect>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.depositPayType}</label>
                                                                    <TreeSelect virtual={false}
                                                                        value={this.state.depositPayType}
                                                                        disabled={this.state.actionType === 'VIEW' ? true : false}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                                        treeCheckable={false}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.depositPayType}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ 'depositPayType': value })
                                                                        }}
                                                                    >
                                                                        <TreeNode value="SAAEI" title='ساعي' key="SAAEI" />
                                                                        <TreeNode value="DEVELOPER" title='المطور' key="DEVELOPER" />
                                                                    </TreeSelect>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            {this.state.actionType === "VIEW" &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form84" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.paymentType}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.paymentType ? this.state.paymentType === "CASH" ? allStrings.cash : allStrings.bank : ""} type="text" id="form84" className="form-control" onChange={this.changeHandler} validate />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }{this.state.actionType === "VIEW" &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form853" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.isCollected}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.isCollected ? allStrings.yes : allStrings.no} type="text" id="form853" className="form-control" onChange={this.changeHandler} validate />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form844" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.collectedDate}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.collectedDate ? moment(this.state.collectedDate).format('dddd D MMMM YYYY hh:mm') : '---'} type="text" id="form844" className="form-control" onChange={this.changeHandler} validate />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.actionType === "VIEW" &&
                                                                <MDBRow>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.type}</label>
                                                                            <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.type === "ONLINE" ? allStrings.onApp : allStrings.outApp} type="text" id="form645" name="type" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="6">
                                                                        <div className="md-form">
                                                                            <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                                                                            <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.status === "BOOKED" ? allStrings.booked : this.state.status === "ACTIVE" ? allStrings.active : allStrings.completed} type="text" id="form56" name="status" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }{this.state.actionType === "VIEW" && this.state.advertisement &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="10" xs="10">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.theAdveristment}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.advertisement ? this.state.advertisement.title : 'مشاهده الاعلان'} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="2" xs="2">

                                                                        <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                                            <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                                                onClick={() => { this.props.history.push('adsInfo', { data: { id: this.state.advertisement.id } }) }}>
                                                                                remove_red_eye
                                                                            </span>
                                                                            <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                                                onClick={() => { this.props.history.push('adsInfo', { data: { id: this.state.advertisement.id } }) }}>
                                                                                {allStrings.show}
                                                                            </span>
                                                                        </p>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.actionType === "VIEW" && this.state.project &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="10" xs="10">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.project ? this.state.project.name : 'مشاهده المشروع'} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="2" xs="2">

                                                                        <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                                            <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                                                onClick={() => { this.props.history.push('projectInfo', { data: this.state.project }) }}>
                                                                                remove_red_eye
                                                                            </span>
                                                                            <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                                                onClick={() => { this.props.history.push('projectInfo', { data: this.state.project }) }}>
                                                                                {allStrings.show}
                                                                            </span>
                                                                        </p>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.actionType === "VIEW" && this.state.user && this.state.user.id !== this.state.actionUser.id &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.client}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.user ? this.state.user.fullname : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.user ? this.state.user.phone : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="2" xs="2">

                                                                        <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                                            <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.user }) }}>
                                                                                remove_red_eye
                                                                            </span>
                                                                            <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.user }) }}>
                                                                                {allStrings.show}
                                                                            </span>
                                                                        </p>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.actionType === "VIEW" && this.state.actionUser &&
                                                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.actionUser}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.actionUser ? this.state.actionUser.fullname : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="5" xs="5">
                                                                        <div class="md-form">
                                                                            <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone}</label>
                                                                            <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.actionUser ? this.state.actionUser.phone : ''} type="text" id="form80" class="form-control" />
                                                                            <div class="valid-feedback">{allStrings.correct}</div>
                                                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                        </div>
                                                                    </MDBCol>
                                                                    <MDBCol md="2" xs="2">

                                                                        <p style={{ textAlign: 'center', marginTop: '2.3rem', color: '#2BBBAD' }}>
                                                                            <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.actionUser }) }}>
                                                                                remove_red_eye
                                                                            </span>
                                                                            <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                                                                onClick={() => { this.props.history.push('userInfo', { data: this.state.actionUser }) }}>
                                                                                {allStrings.show}
                                                                            </span>
                                                                        </p>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                            }
                                                            {this.state.actionType === "VIEW" && this.state.recieptFile != null &&
                                                                <div>
                                                                    <label htmlFor="form062" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.recieptFile}</label>
                                                                    <div>
                                                                        <a href={this.state.recieptFile} target="blank" style={{
                                                                            background: 'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)',
                                                                            color: '#fff',
                                                                            padding: '3px 40px',
                                                                            marginLeft: '15px'
                                                                        }}
                                                                        >
                                                                            {allStrings.openFile}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            }

                                                        </div>
                                                        <br></br>
                                                        <br></br>
                                                        <div className="text-center">
                                                            {this.state.actionType === "EDIT" &&
                                                                <MDBBtn
                                                                    style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                                                                    rounded
                                                                    color="#1D9598"
                                                                    type="submit"
                                                                    className="btn-block z-depth-1a"
                                                                >
                                                                    <MDBIcon icon="edit" className="mr-2" />
                                                                    {allStrings.update}
                                                                </MDBBtn>
                                                            }
                                                        </div>
                                                    </form>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBContainer>
                                    </CardContent>
                                </Card>
                            </div>
                        </MDBCol>
                    </MDBRow>
                    {this.state.actionType === "VIEW" &&
                        this.installmentsTable()
                    }
                    {this.state.actionType === "VIEW" &&
                        this.attachmentsTable()
                    }
                </MDBContainer>
            </div>
        )
    }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(DealInfo)
);
